<template>
  <div class="thumb editorpick-cell">
    <a href="#" @click.prevent="goDetail(cellInfo)">
      <div class="thumb-image">
        <img v-lazy="getInnerPosterLazyImage()" class="thumb-img" :alt="altTitle"/>
        <!--        <img alt="?" class="thumb-img" src="../images/common/@poster.jpg" aria-hidden="true">-->
      </div>
      <div class="sub-title">
        <div class="sub-right" ref="title"
             v-title-list="{
                 'titleList': cellInfo.title_list,
             }">
        </div>
      </div>
    </a>
    <div class="editorpick-cell-backdrop" :style="backgroundImage"></div>
  </div>
</template>
<script>
import CellMixIn from '@/mixins/cell.mixin'
import { bottomTagList, titleList, topTagList } from '@/common/resources/directives'
import _ from 'lodash'
import shave from '@/common/utils/customShave'
import { resizeThumbnail } from '@/common/utils/image'

export default {
  name: 'templateEditorPick',
  mixins: [
    CellMixIn
  ],
  directives: {
    titleList,
    topTagList,
    bottomTagList
  },
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    }
  },
  data () {
    return {}
  },
  computed: {
    altTitle () {
      let title = ''
      _.get(this.cellInfo, 'title_list', []).forEach((titleItem) => {
        title += ' ' + titleItem.text
      })
      return title
    },
    backgroundImage () {
      const IMAGE_WIDTH = '_w960'
      const PC_BLUR_KEY = '_blur2'
      const thumbnailUrl = _.get(this.cellInfo, 'thumbnail', '').replace('http://', '').replace('https://', '')
      if (thumbnailUrl === '') return
      const pathArr = thumbnailUrl.split('/')
      const fileNameAndExt = pathArr.pop()
      const [fileName, ext] = fileNameAndExt.split('.')
      const completeFileName = [fileName + IMAGE_WIDTH + PC_BLUR_KEY, ext].join('.')
      const blurImagePath = [...pathArr, completeFileName].join('/')
      return `background-image: url(${location.protocol}//${blurImagePath});`
    }

  },
  methods: {
    loaded (el) {
      this.$nextTick(() => {
        _.forEach(el.querySelectorAll('.line1'), (line1El) => {
          shave(line1El, 28)
        })
      })
    },
    getInnerPosterLazyImage () {
      let thumbnail = _.get(this.cellInfo, 'thumbnail', '')
      if (thumbnail === '') {
        thumbnail = this.thumbnailInfo.placeholderImage
      }
      return {
        src: resizeThumbnail(thumbnail, {
          width: 128,
          height: 180,
          isSquare: false
        }),
        error: this.thumbnailInfo.placeholderImage,
        loading: this.thumbnailInfo.placeholderImage
      }
    }
  }
}
</script>
